// extracted by mini-css-extract-plugin
export default {"section":"Projects_section__xvGpB","sectionTitleWrapper":"Projects_sectionTitleWrapper__bPcZa","row":"Projects_row__0QH4A","flexPrint":"Projects_flexPrint__huhWB"};